import React from "react";
import Button from "components/Button";

import html2pdf from "html2pdf.js/dist/html2pdf.min.js";

import { colors, strings } from "assets/constants";
import { useFlag } from "hooks";

const ExportPDF: React.FC<ExportPDF> = ({ template, button, extraData }) => {
  const { flg: loading, on: startLoading, off: stopLoading } = useFlag();

  const _onExportPdf = () => {
    startLoading();
    html2pdf()
      .set({
        margin: 12,
        filename: `${strings.factor} ${
          extraData.customer.name
        } (${extraData.updated_at.replace(/\//g, "-")}).pdf`,
        image: { type: "png", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: "portrait" },
      })
      .from(template)
      .save()
      .then(stopLoading);
  };

  return (
    <>
      <Button
        loading={loading}
        onPress={_onExportPdf}
        bgColor={colors.blue}
        absolute
        {...button}
      />
    </>
  );
};

export default ExportPDF;
